import React, { Component } from 'react'
import { Div, Image, Text } from "atomize";
import WebsiteContainer from '../common/WebsiteContainer';
import CustomContainer from '../common/CustomContainer';
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

export default class BuzzAnalytics extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
          <Div m={{t: "10rem"}} pos="relative" className="solutions">
            <Div d={{xs: "none", md: "block"}}>
              <ImageLink link=""><Image 
                src={content.graphImg}
                m={{t: "14rem"}}
              /></ImageLink>
            </Div>
            <Div pos={{xs: "initial", md: "absolute"}} top="0" d="flex" flexDir={{xs: "column-reverse", md: "row"}} justify="space-between">
              <Div flexGrow="1" d="flex" flexDir="column" justify="center">
                <Text p={{r:"1rem"}} m={{b:"1rem", t: {xs: "3rem", md: "0"}}} tag="h2" textSize={{xs: "26px", md: "title2"}} style={{lineHeight: "34px"}} textWeight="700">
                  {content.heading}
                </Text>
                <Text textSize={{xs: "15px", md: "paragraph"}} className="sub-text" textColor="#D9D9D9">
                  {content.text}
                </Text>
              </Div>
              <Div p={{xs: "0", md: "2.5rem"}} flexGrow="1">
                <ImageLink link={content.imgLink}><Div
                  bgImg={content.image}
                  p={{b: "71%"}}
                  bgSize="cover"
                  bgRepeat="no-repeat"
                ></Div></ImageLink>
              </Div>
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
